"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MhTable = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _tableStore = require("./tableStore");

var _headTable = require("./headTable");

var _bodyTable = require("./bodyTable");

var _lodash = _interopRequireDefault(require("lodash"));

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MhTable = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    HeadTable: _headTable.HeadTable,
    BodyTable: _bodyTable.BodyTable
  }
}), _dec2 = (0, _vuePropertyDecorator.Provide)(), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec5 = (0, _vuePropertyDecorator.Prop)({
  default: 'key'
}), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec7 = (0, _vuePropertyDecorator.Prop)(), _dec8 = (0, _vuePropertyDecorator.Prop)({
  default: 'middle'
}), _dec9 = (0, _vuePropertyDecorator.Prop)({
  default: false
}), _dec10 = (0, _vuePropertyDecorator.Prop)({
  default: false
}), _dec11 = (0, _vuePropertyDecorator.Prop)(), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(MhTable, _Vue);

  var _super = _createSuper(MhTable);

  function MhTable() {
    var _this;

    (0, _classCallCheck2.default)(this, MhTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "columns", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "dataSource", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "rowKey", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "scroll", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "customRow", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "size", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "bordered", _descriptor7, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "loading", _descriptor8, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "footerData", _descriptor9, (0, _assertThisInitialized2.default)(_this));
    _this.tableStore = new _tableStore.TableStore();
    _this.scrollPosition = 'left';
    _this.nodes = {};
    _this.debouncedWindowResize = _lodash.default.debounce(_this.handleWindowResize, 150);
    _this.lastScrollLeft = 0;
    _this.lastScrollTop = 0;
    return _this;
  }

  (0, _createClass2.default)(MhTable, [{
    key: "table",
    get: function get() {
      return this;
    }
  }, {
    key: "tableBodyFixedLeftColumns",
    get: function get() {
      var _this$columns, _this$columns2;

      var leftColumnsIndex = (_this$columns = this.columns) === null || _this$columns === void 0 ? void 0 : _this$columns.findIndex(function (col) {
        var _col$children;

        return col.fixed !== 'left' || ((_col$children = col.children) === null || _col$children === void 0 ? void 0 : _col$children.length);
      });
      return leftColumnsIndex !== 0 ? (_this$columns2 = this.columns) === null || _this$columns2 === void 0 ? void 0 : _this$columns2.slice(0, leftColumnsIndex) : [] || [];
    }
  }, {
    key: "tableBodyFixedRightColumns",
    get: function get() {
      var _this$columns3, _this$columns4;

      var rightColumnsIndex = (_this$columns3 = this.columns) === null || _this$columns3 === void 0 ? void 0 : _this$columns3.slice().reverse().findIndex(function (col) {
        var _col$children2;

        return col.fixed !== 'right' || ((_col$children2 = col.children) === null || _col$children2 === void 0 ? void 0 : _col$children2.length);
      });
      return rightColumnsIndex !== 0 ? (_this$columns4 = this.columns) === null || _this$columns4 === void 0 ? void 0 : _this$columns4.slice(-rightColumnsIndex) : [] || [];
    }
  }, {
    key: "isAnyColumnsFixed",
    get: function get() {
      var _this$tableBodyFixedL, _this$tableBodyFixedR;

      return !!((_this$tableBodyFixedL = this.tableBodyFixedLeftColumns) !== null && _this$tableBodyFixedL !== void 0 && _this$tableBodyFixedL.length || (_this$tableBodyFixedR = this.tableBodyFixedRightColumns) !== null && _this$tableBodyFixedR !== void 0 && _this$tableBodyFixedR.length);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.isAnyColumnsFixed) {
          _this2.handleWindowResize();

          window.addEventListener('resize', _this2.debouncedWindowResize);
        }
      });
    }
  }, {
    key: "updated",
    value: function updated() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.isAnyColumnsFixed) {
          _this3.handleWindowResize();
        }
      });
    }
  }, {
    key: "saveRefNode",
    value: function saveRefNode(name) {
      var _this4 = this;

      return function (node) {
        _this4.nodes[name] = node;
      };
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var _this$$refs$contentTa, _this$$refs$contentTa2;

      var tableStore = this.tableStore;
      var theadRows = ((_this$$refs$contentTa = this.$refs.contentTable) === null || _this$$refs$contentTa === void 0 ? void 0 : _this$$refs$contentTa.querySelectorAll('thead')) || [];
      var tbodyRows = ((_this$$refs$contentTa2 = this.$refs.contentTable) === null || _this$$refs$contentTa2 === void 0 ? void 0 : _this$$refs$contentTa2.querySelectorAll('.ant-table-row')) || [];
      tableStore.fixedColumnsHeadRowsHeight = [].map.call(theadRows, function (row) {
        return row.getBoundingClientRect().height ? row.getBoundingClientRect().height - 0.5 : 'auto';
      });
      tableStore.fixedColumnsBodyRowsHeight = [].reduce.call(tbodyRows, function (acc, row) {
        var rowKey = row === null || row === void 0 ? void 0 : row.getAttribute('data-row-key');
        acc[rowKey] = (row === null || row === void 0 ? void 0 : row.getBoundingClientRect().height) || tableStore.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
        return acc;
      }, {});
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(position) {
      this.scrollPosition = position;
    }
  }, {
    key: "setScrollPositionClassName",
    value: function setScrollPositionClassName() {
      var bodyTable = this.nodes.bodyTable;
      var scrollToLeft = bodyTable.scrollLeft === 0;
      var scrollToRight = bodyTable.scrollLeft + 1 >= bodyTable.children[0].getBoundingClientRect().width - bodyTable.getBoundingClientRect().width;

      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    }
  }, {
    key: "handleBodyScrollLeft",
    value: function handleBodyScrollLeft(e) {
      var target = e.target;

      if (e.currentTarget !== target) {
        return;
      }

      var scroll = this.scroll;
      var _this$nodes = this.nodes,
          headTable = _this$nodes.headTable,
          bodyTable = _this$nodes.bodyTable,
          _this$nodes$footerBod = _this$nodes.footerBodyTable,
          footerBodyTable = _this$nodes$footerBod === void 0 ? {} : _this$nodes$footerBod;

      if ((target === null || target === void 0 ? void 0 : target.scrollLeft) !== this.lastScrollLeft && scroll !== null && scroll !== void 0 && scroll.x) {
        if (target === bodyTable && headTable) {
          headTable.scrollLeft = target.scrollLeft;
          footerBodyTable.scrollLeft = target.scrollLeft;
        } else if (target === headTable && bodyTable) {
          bodyTable.scrollLeft = target.scrollLeft;
          footerBodyTable.scrollLeft = target.scrollLeft;
        } else if (target === footerBodyTable && headTable && bodyTable) {
          headTable.scrollLeft = target.scrollLeft;
          bodyTable.scrollLeft = target.scrollLeft;
        }

        this.setScrollPositionClassName();
      } // Remember last scrollLeft for scroll direction detecting.


      this.lastScrollLeft = target.scrollLeft;
    }
  }, {
    key: "handleBodyScrollTop",
    value: function handleBodyScrollTop(e) {
      var target = e.target;

      if (e.currentTarget !== target) {
        return;
      }

      var scroll = this.scroll;
      var _this$nodes2 = this.nodes,
          headTable = _this$nodes2.headTable,
          bodyTable = _this$nodes2.bodyTable,
          leftFixedBodyTable = _this$nodes2.leftFixedBodyTable,
          rightFixedBodyTable = _this$nodes2.rightFixedBodyTable;

      if (target.scrollTop !== this.lastScrollTop && scroll.y && target !== headTable) {
        var scrollTop = target.scrollTop;

        if (leftFixedBodyTable && target !== leftFixedBodyTable) {
          leftFixedBodyTable.scrollTop = scrollTop;
        }

        if (rightFixedBodyTable && target !== rightFixedBodyTable) {
          rightFixedBodyTable.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      } // Remember last scrollTop for scroll direction detecting.


      this.lastScrollTop = target.scrollTop;
    }
  }, {
    key: "handleBodyScroll",
    value: function handleBodyScroll(e) {
      this.handleBodyScrollLeft(e);
      this.handleBodyScrollTop(e);
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(e) {
      var scroll = this.$props.scroll;

      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
        e.preventDefault();
        var wd = e.deltaY;
        var target = e.target;
        var _this$nodes3 = this.nodes,
            bodyTable = _this$nodes3.bodyTable,
            leftFixedBodyTable = _this$nodes3.leftFixedBodyTable,
            rightFixedBodyTable = _this$nodes3.rightFixedBodyTable;
        var scrollTop = 0;

        if (this.lastScrollTop) {
          scrollTop = this.lastScrollTop + wd;
        } else {
          scrollTop = wd;
        }

        if (leftFixedBodyTable && target !== leftFixedBodyTable) {
          leftFixedBodyTable.scrollTop = scrollTop;
        }

        if (rightFixedBodyTable && target !== rightFixedBodyTable) {
          rightFixedBodyTable.scrollTop = scrollTop;
        }

        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
    }
  }, {
    key: "renderTable",
    value: function renderTable(fixed, footer) {
      var _this5 = this;

      var h = this.$createElement;
      var _this$scroll = this.scroll,
          scroll = _this$scroll === void 0 ? {} : _this$scroll;

      if (footer) {
        return h("body-table", {
          "key": "body",
          "attrs": {
            "fixed": fixed,
            "scroll": scroll,
            "footer": true
          }
        });
      }

      return [h("head-table", {
        "key": "head",
        "attrs": {
          "fixed": fixed,
          "scroll": scroll
        }
      }), h("body-table", (0, _babelHelperVueJsxMergeProps.default)([{
        "key": "body",
        "attrs": {
          "fixed": fixed,
          "scroll": scroll
        }
      }, {
        scopedSlots: {
          tableTop: function tableTop() {
            var _this5$$slots, _this5$$slots2;

            return (_this5$$slots = _this5.$slots) === null || _this5$$slots === void 0 ? void 0 : (_this5$$slots2 = _this5$$slots[fixed ? "".concat(fixed, "FixedTableTop") : 'tableTop']) === null || _this5$$slots2 === void 0 ? void 0 : _this5$$slots2[0];
          },
          tableBottom: function tableBottom() {
            var _this5$$slots3, _this5$$slots4;

            return (_this5$$slots3 = _this5.$slots) === null || _this5$$slots3 === void 0 ? void 0 : (_this5$$slots4 = _this5$$slots3[fixed ? "".concat(fixed, "FixedTableBottom") : 'tableBottom']) === null || _this5$$slots4 === void 0 ? void 0 : _this5$$slots4[0];
          }
        }
      }]))];
    }
  }, {
    key: "renderContentTable",
    value: function renderContentTable(footer) {
      var h = this.$createElement;
      var scroll = this.scroll,
          isAnyColumnsFixed = this.isAnyColumnsFixed,
          footerData = this.footerData;
      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;
      return scrollable ? h("div", {
        "class": "ant-table-scroll",
        "style": {
          'overflow-y': footerData ? 'hidden' : undefined
        },
        "ref": footer ? 'footerContentTable' : 'contentTable',
        "key": "contentTable"
      }, [this.renderTable(undefined, footer)]) : this.renderTable(undefined, footer);
    }
  }, {
    key: "renderFixedTable",
    value: function renderFixedTable(position, footer) {
      var h = this.$createElement;
      var columns = position === 'left' ? this.tableBodyFixedLeftColumns : this.tableBodyFixedRightColumns;

      if (!columns.length) {
        return undefined;
      }

      return h("div", {
        "class": (0, _defineProperty2.default)({}, "ant-table-fixed-".concat(position), true),
        "style": {
          top: footer ? '1px' : undefined
        }
      }, [this.renderTable(position, footer)]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$scroll2, _ref2;

      var h = arguments[0];
      var loading = this.loading,
          size = this.size,
          bordered = this.bordered,
          footerData = this.footerData,
          scrollPosition = this.scrollPosition;
      var footerTable = footerData ? h("div", {
        "class": "ant-table-footer-table",
        "key": "footerTable"
      }, [this.renderContentTable(true), this.renderFixedTable('left', true), this.renderFixedTable('right', true)]) : undefined;
      return h("div", {
        "class": "ant-table-wrapper"
      }, [h("a-spin", {
        "attrs": {
          "spinning": loading
        }
      }, [h("div", {
        "class": (_ref2 = {
          'ant-table': true,
          'ant-table-default': true,
          'ant-table-layout-fixed': true,
          'ant-table-fixed-header': (_this$scroll2 = this.scroll) === null || _this$scroll2 === void 0 ? void 0 : _this$scroll2.y
        }, (0, _defineProperty2.default)(_ref2, "ant-table-scroll-position-".concat(size), true), (0, _defineProperty2.default)(_ref2, 'ant-table-bordered', bordered !== null && bordered !== false), (0, _defineProperty2.default)(_ref2, 'ant-table-scroll-position-left ant-table-scroll-position-right', scrollPosition === 'both'), (0, _defineProperty2.default)(_ref2, "ant-table-scroll-position-".concat(scrollPosition), scrollPosition !== 'both'), _ref2),
        "ref": "root"
      }, [h("div", {
        "class": "ant-table-content",
        "key": "contentTable"
      }, [this.renderContentTable(), this.renderFixedTable('left'), this.renderFixedTable('right')]), footerTable])])]);
    }
  }]);
  return MhTable;
}(_vuePropertyDecorator.Vue), _temp), ((0, _applyDecoratedDescriptor2.default)(_class2.prototype, "table", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "table"), _class2.prototype), _descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "columns", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "dataSource", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "rowKey", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "scroll", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "customRow", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "size", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "bordered", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "loading", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "footerData", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.MhTable = MhTable;